<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="750px"
    :innerScroll="false"
    :loading="loadingButtom"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form :model="addForm" ref="addForm" :rules="rules" size="mini" label-width="80px" class="content">
      <el-row>
        <el-col :span="12">
          <el-form-item label="质检条目" prop="checkCategory">
            <el-input v-model.trim="addForm.checkCategory" maxlength="100" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="违规项" prop="categoryDetail">
            <el-input v-model.trim="addForm.categoryDetail" maxlength="100" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-for="(item, index) in addForm.updateList" :key="index">
        <el-col :span="12">
          <el-form-item label="场景" :prop="'updateList.' + index + '.scene'" :rules="rules.scene">
            <el-input v-model.trim="item.scene" maxlength="100" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="扣分" :prop="'updateList.' + index + '.assessmentScore'" :rules="rules.assessmentScore">
            <el-input v-model.trim="item.assessmentScore" maxlength="100" @input="buyPriceInput(item, 'assessmentScore')" placeholder="请输入" style="margin-right: 5px"></el-input>
            <el-button type="text" @click="addRow(index)" v-if="index == 0">添加</el-button>
            <el-button type="text" style="color: red" @click="delRow(index)" v-if="index > 0">删除</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="状态" prop="status">
            <el-radio v-model="addForm.status" label="启用">启用</el-radio>
            <el-radio v-model="addForm.status" label="禁用">禁用</el-radio>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="生效时间" prop="effectDate">
            <el-date-picker v-model="addForm.effectDate" type="date" value-format="yyyyMMdd" placeholder="年/月/日" :picker-options="pickerOptions"> </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否通报" prop="isReport">
            <el-radio-group v-model="addForm.isReport" @input="isReportChange">
            <el-radio label="是">是</el-radio>
            <el-radio label="否">否</el-radio>
          </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="通报时长" prop="reportDuration">
            <el-input v-model="addForm.reportDuration" @input="sortNumInput" />
            <span style="margin-left: 5px">天</span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="说明" prop="describe">
            <el-input v-model="addForm.describe" type="textarea" :rows="3" placeholder="请输入描述信息"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </q-dialog>
</template>

<script>
export default {
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    // refundReasonList: {
    //   type: Array,
    //   default: [],
    // },
    rowData: Object,
  },
  data() {
    return {
      addForm: {
        updateList: [{ checkCategory: "", categoryDetail: "", scene: "", assessmentScore: "" }],
        isReport: '否'
      },
      userId: "",
      userList: [],
      all: false,
      rules: {
        checkCategory: [{ required: true, message: "不能为空", trigger: "blur" }],
        categoryDetail: [{ required: true, message: "不能为空", trigger: "blur" }],
        scene: [{ required: true, message: "不能为空", trigger: "blur" }],
        assessmentScore: [{ required: true, message: "不能为空", trigger: "blur" }],
        effectDate: [{ required: true, message: "不能为空", trigger: "change" }],
        status: [{ required: true, message: "不能为空", trigger: "change" }],
        isReport: [{ required: true, message: "不能为空", trigger: "change" }],
        reportDuration: [{ required: false, message: "不能为空", trigger: "blur" }],
      },
      loading: false,
      loadingButtom: false,
      authOptions: [],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return "新增";
    },
  },
  mounted() {
    if (this.rowData) {
      let addForm = JSON.parse(JSON.stringify(this.rowData));
      this.addForm = addForm;
    }
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.loadingButtom = true;
        let data = this.addForm.updateList.map((v) => {
          return {
            ...v,
            checkCategory: this.addForm.checkCategory,
            categoryDetail: this.addForm.categoryDetail,
            effectDate: this.addForm.effectDate,
            status: this.addForm.status,
            describe: this.addForm.describe,
            reportDuration: this.addForm.reportDuration,
            isReport: this.addForm.isReport == '是' ? 1 : 0
          };
        });
        this.$q.qualityTestingManage
          .projectConfigAdd({ data: data })
          .then((res) => {
            if (res.code == 200) {
              this.$message.success("新增成功");
              this.isVisible = false;
              this.$emit("success");
            }
          })
          .finally((_) => {
            this.loadingButtom = false;
          });
      });
    },
    isReportChange(val) {
      if(val == '是') {
        this.rules.reportDuration[0].required = true;
      }else{
        this.rules.reportDuration[0].required = false;
        this.$set(this.addForm, 'reportDuration', '')
        this.$refs.addForm.clearValidate('reportDuration');
      }
    },
    addRow(index) {
      this.addForm.updateList.push({ checkCategory: "", categoryDetail: "", scene: "", assessmentScore: "" });
    },
    delRow(index) {
      this.addForm.updateList.splice(index, 1);
    },
    sortNumInput(val) {
      // 只允许输入正整数（非0），去除非数字和前导0
      let num = val.replace(/[^\d]/g, '');
      num = num.replace(/^0+/, '');
      this.addForm.reportDuration = num;
    },
    //只能输入正数并小数点保留1位
    buyPriceInput(item, name) {
      var price = "" + item[name];
      price = price
        .replace(/[^\d.]/g, "") // 清除“数字”和“.”以外的字符
        .replace(/\.{2,}/g, ".") // 只保留第一个. 清除多余的
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".")
        .replace(/^(\-)*(\d+)\.(\d).*$/, "$1$2.$3"); // 只能输入两个小数
      if (price.indexOf(".") < 0 && price != "") {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        price = parseFloat(price);
      }
      item[name] = price;
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-input--small .el-input__inner, >>> .el-date-editor.el-input, >>> .el-date-editor.el-input__inner
  width 240px !important
>>> .el-input
  width 240px !important

>>> .el-input-number--mini {
    width: 240px !important;
}

>>> .el-dialog {
  margin: 50px auto !important
}

.content {
  max-height: 70vh
  overflow-y: auto
}
</style>
